import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid,
    InputLabel,
    Input
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import * as logger from '../../../logger';
import { numberWithCommas, replaceCommas, checkNumberOnly, getDateInStringDocumentDDMMMYYYY } from '../../../utils/utils';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { markPaidDialogCss as useStyles } from './VehicleDialogCss';
import { addVendorExpense } from "../../../store/actions/tripActionCreator";
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';


const MarkPaidDialog = ({ open, onClose, vehicle, onConfirm, vehicleIdValue, user, expenseDetails, dispacthAddExpenses }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [emiAmount, setEmiAmount] = useState("");

    const classes = useStyles();
    let emiBookDetails = vehicle && vehicle.truckBooks ? vehicle.truckBooks : ""

    const initialValues = {
        amount: emiAmount ? emiAmount : expenseDetails && expenseDetails.amount ? numberWithCommas(expenseDetails.amount) : "",
        paymentDate: new Date()
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Amount Paid</div>
                            <AmountInput
                                placeholder="Amount Paid"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setEmiAmount(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Payment Date</div>
                        <DatePicker
                            disableFuture
                            name="paymentDate"
                            margin="none"
                            variant="inline"
                            fullWidth={true}
                            inputVariant="outlined"
                            size="small"
                            format="dd MMM yyyy"
                            placeholder="Payment Date"
                            dateFunsUtils={DateFnsUtils}
                            required={true}
                            className={classes.marginV1}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                        />
                    </div>
                )
            }
        ]
    }

    const validate = values => {

        const errors = {}

        if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
            errors.amount = "Please enter valid amount."
        }

        return errors;

    }

    const onSubmit = values => {

        var data = {
            vehicleId: Number(vehicleIdValue),
            amount: replaceCommas(values.amount),
            expenseParentType: "emi",
            fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
            expenseDate: values.paymentDate ? Number(Math.round((values.paymentDate.setHours(0, 0, 0, 0) / 1000))) : "",
            emiDate: expenseDetails && expenseDetails.emiDate ? expenseDetails.emiDate : "",
        }

        dispacthAddExpenses(data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    trackDwebEvent("Dweb SVP EMI Mark Paid Completed Successfully", {
                        vehicle_id: emiBookDetails && emiBookDetails.vehicleId ? emiBookDetails.vehicleId : "",
                        vehicle_number: emiBookDetails && emiBookDetails.vehicleNumber ? emiBookDetails.vehicleNumber : "",
                        emi_amount: values && values.amount ? values.amount : "",
                        emi_payment_date: values && values.paymentDate ? new Date(values.paymentDate * 1000) : "",
                        emi_id: emiBookDetails && emiBookDetails.id ? emiBookDetails.id : "",
                        emi_due_date: emiBookDetails && (emiBookDetails.displayDate || emiBookDetails.dispayDate) ? new Date((emiBookDetails.displayDate || emiBookDetails.dispayDate) * 1000) : "",
                    });
                    logger.log("EMI Book Dweb", "Add payment successfull");
                    setDialogOpen(false);
                    onConfirm();
                }
            },
            () => {
                logger.log("EMI Book Dweb", "Add payment failed");
            }
        );

    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='sm'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>EMI&nbsp;{expenseDetails && expenseDetails.emiDate ? getDateInStringDocumentDDMMMYYYY(expenseDetails.emiDate) : ""}</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarkPaidDialog);